// src/pages/CancelPage.js

import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function CancelPage() {
    const navigate = useNavigate();

    const handleRetry = () => {
        navigate(-1); // Navigate back to the previous page (Transaction Details)
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom>
                Payment Canceled
            </Typography>
            <Typography variant="body1" gutterBottom>
                Your payment was not completed. If you have any questions or need assistance, please contact our support team.
            </Typography>
            <Box mt={4}>
                <Button variant="contained" color="primary" onClick={handleRetry}>
                    Retry Payment
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => navigate('/bookings')}
                    sx={{ ml: 2 }}
                >
                    Go to My Bookings
                </Button>
            </Box>
        </Container>
    );
}

export default CancelPage;
